import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-left\"><defs><style type=\"text/css\"></style></defs><path d=\"M256 512l512 512 0-135.776-376.224-376.224 376.224-376.256 0-135.745z\" p-id=\"1101\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol